import LoginForm from "./LoginForm";
import withStyles from "react-jss";
import styles from "./styles";
import Form from "antd/lib/form";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { loginRequest, registerRequest } from "./ducks/actions";
var mapStateToProps = function (state) {
    return {
        messageInfo: state.app.message,
        errorInfo: state.auth.errors
    };
};
var mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        loginRequest: loginRequest,
        registerRequest: registerRequest
    }, dispatch);
};
export default Form.create({ name: "login" })(withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(LoginForm)));



//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForm/index.tsx
// module id = 356
// module chunks = 0